import type { ReactNode, HTMLAttributes } from "react";

/**
 * Cadre à double filet — refonte mobile 2026-08-06 (maquette Claude Design).
 *
 * Le motif signature des réclames encadrées de 1888 : un filet d'encre, un
 * blanc de respiration, un second filet, et des équerres d'angle qui ne
 * ferment pas le cadre. Répété une quinzaine de fois dans la maquette, donc
 * un composant plutôt qu'un copier-coller.
 *
 * Le double filet est obtenu par `box-shadow` interne (cf. `.frame` dans
 * cockpit.css) : il ne consomme aucun pseudo-élément de l'enfant, et reste
 * donc posable sur des blocs qui utilisent déjà les leurs.
 */

interface Props extends HTMLAttributes<HTMLDivElement> {
  /** Fond de la respiration entre les deux filets — doit égaler le fond réel. */
  variant?: "paper" | "panel" | "panel-2" | "ink";
  /**
   * `diagonal` : deux équerres opposées, dessinées en pseudo-éléments (aucun
   * nœud ajouté). `all` : les quatre, qui demandent quatre `<span>`.
   */
  corners?: "none" | "diagonal" | "all";
  children: ReactNode;
}

export function Frame({
  variant = "paper",
  corners = "diagonal",
  className,
  children,
  ...rest
}: Props) {
  return (
    <div
      className={["frame", className].filter(Boolean).join(" ")}
      data-frame={variant}
      data-corners={corners}
      {...rest}
    >
      {corners === "all" && (
        <>
          <span className="frame-corner" data-at="tl" aria-hidden="true" />
          <span className="frame-corner" data-at="tr" aria-hidden="true" />
          <span className="frame-corner" data-at="bl" aria-hidden="true" />
          <span className="frame-corner" data-at="br" aria-hidden="true" />
        </>
      )}
      {children}
    </div>
  );
}
